module.exports = __webpack_public_path__ + "static/img/zhuan3.fb5d50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/zhuan3.png
// module id = Wb+T
// module chunks = 1